export const MIN_QUERY_VALUE = 1

export const MAX_RESULTS_PER_PAGE = 9
